module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div data-name=\"")
    ; __append(escapeFn( typeof(name) != "undefined" ? name : "" ))
    ; __append("\" class=\"menu__item\" on-click=\"onItemClick\">\n	<span>")
    ; __append(escapeFn( typeof(title) != "undefined" ? title : "" ))
    ; __append("</span>\n</div>\n")
  }
  return __output.join("");

}